import { format } from 'date-fns-tz';

import { Timezone } from './external/charting_library';

/**
 * Chart support only few timesones
 * https://github.com/tradingview/charting_library/wiki/Symbology#timezone
 * 'Etc/UTC' | CustomTimezones;
 */
const supported: Timezone[] = [
  'Etc/UTC',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'America/Argentina/Buenos_Aires',
  'America/Bogota',
  'America/Caracas',
  'America/Chicago',
  'America/El_Salvador',
  'America/Juneau',
  'America/Lima',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/New_York',
  'America/Phoenix',
  'America/Santiago',
  'America/Sao_Paulo',
  'America/Toronto',
  'America/Vancouver',
  'Asia/Almaty',
  'Asia/Ashkhabad',
  'Asia/Bahrain',
  'Asia/Bangkok',
  'Asia/Chongqing',
  'Asia/Dubai',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Jakarta',
  'Asia/Jerusalem',
  'Asia/Kathmandu',
  'Asia/Kolkata',
  'Asia/Kuwait',
  'Asia/Muscat',
  'Asia/Qatar',
  'Asia/Riyadh',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Taipei',
  'Asia/Tehran',
  'Asia/Tokyo',
  'Atlantic/Reykjavik',
  // 'Australia/ACT',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Copenhagen',
  'Europe/Helsinki',
  'Europe/Istanbul',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Moscow',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Europe/Warsaw',
  'Europe/Zurich',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Pacific/Fakaofo',
  'Pacific/Honolulu',
  'Pacific/Norfolk',
  'US/Mountain',
];

const getUserTimezone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.warn(error);
  }
};

// https://www.tradingview.com/charting-library-docs/latest/api/interfaces/Charting_Library.ITimezoneApi
// TODO: chart timezone deprecated https://github.com/tradingview/charting_library/wiki/Breaking-Changes#version-22
const getTimezoneOffset = (
  timestamp: number,
  timeZone: string
): string | undefined => {
  try {
    // const tz = date.toLocaleString("en", {timeZone, timeStyle: "long"}).split(" ").slice(-1)[0];
    return format(timestamp, 'X', { timeZone });
  } catch (error) {
    console.warn(error);
  }
};

export const detectChartTimezone = (
  userTimeZone: string | undefined = getUserTimezone()
): Timezone => {
  if (!userTimeZone) {
    return supported[0];
  }
  const exactFound = supported.find(timezone => timezone === userTimeZone);
  if (exactFound) {
    return exactFound;
  }
  // Now we just do guessing..
  const nowTs = Date.now();
  const userTsOffset = getTimezoneOffset(nowTs, userTimeZone);
  if (!userTsOffset) {
    return supported[0];
  }

  // Try to find timezone on user continent fist
  const guessedContinent = userTimeZone.split('/')[0];
  const foundInContinent = supported
    .filter(zone => zone.startsWith(guessedContinent))
    .find(zone => userTsOffset === getTimezoneOffset(nowTs, zone));

  if (foundInContinent) {
    return foundInContinent;
  }

  const found = supported.find(
    zone => userTsOffset === getTimezoneOffset(nowTs, zone)
  );

  return found || supported[0];
};
